export default __webpack_public_path__ + "static/media/logo-color.259dc3cb.png";